import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { CONTATTI, NAV, SOCIAL } from "@/lib/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="mt-16">
    <div className="border-t border-gray-300 shadow-[0_-6px_8px_-6px_rgba(0,0,0,0.35)]">
      <div className="max-w-[1240px] mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-2 gap-8">
        <img src="/img/ivcasa_footer.jpg" alt="IVCasa - FIAIP" className="w-[200px] h-auto" />
        <div className="md:text-right text-sm leading-7">
          <p className="font-tit font-bold text-[var(--iv)] text-2xl sm:text-[32px] uppercase leading-tight mb-3">IVCasa - Gruppo Immobiliare</p>
          <p className="font-bold">{CONTATTI.ragione}</p>
          <p className="font-bold">P. IVA {CONTATTI.piva}</p>
          <p className="font-bold">{CONTATTI.sede}</p>
          <p className="font-bold">Tel: {CONTATTI.telSede}</p>
          <p className="font-bold">REA {CONTATTI.rea}</p>
        </div>
      </div>
    </div>
    <div className="relative bg-[var(--iv)] text-white">
      <div className="absolute left-1/2 -translate-x-1/2 -top-6 flex gap-3">
        {[["facebook", Facebook], ["instagram", Instagram]].map(([k, Icon]) => (
          <a key={k} href={SOCIAL[k]} target="_blank" rel="noreferrer" aria-label={k} data-testid={`footer-${k}-link`}
            className="w-12 h-12 rounded-full bg-white text-[#222] grid place-items-center shadow-[0_3px_5px_rgba(0,0,0,0.35)] hover:text-[var(--iv)] transition-colors">
            <Icon className="w-6 h-6" />
          </a>
        ))}
      </div>
      <div className="max-w-[1240px] mx-auto px-4 pt-12 pb-6 flex flex-col md:flex-row gap-4 justify-between text-sm">
        <nav className="flex flex-wrap gap-x-2 gap-y-1">
          <span className="font-bold">Mappa</span>
          {NAV.map((n) => (
            <span key={n.to}>» <Link to={n.to} className="hover:underline" data-testid={`footer-nav-${n.to === "/" ? "home" : n.to.slice(1)}`}>{n.label}</Link></span>
          ))}
        </nav>
        <p className="font-bold">
          <Link to="/admin" className="hover:underline" data-testid="footer-admin-link">Area riservata</Link> - Privacy
        </p>
      </div>
    </div>
  </footer>
);
